// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c9e4e1eb","126":"b39a096a","189":"2a830425","256":"0a038731","639":"6209a048","711":"95ddb0bb","787":"1ed0c42c","827":"1578d66a","853":"ee0cc65e","966":"96047057"}[chunkId] + ".chunk.js";
};